const translations = {
  pt: {
    reading: "Leitura",
    backToBooks: "Voltar para seleção de livros",
    failBooks: "Falha ao buscar livros: ",
    selectBook: "Selecione um Livro",
    libraryLead: "Escolha um livro para começar a leitura.",
    noBooks: "Nenhum livro disponível",
    noBooksDescription: "Ainda não há livros publicados para leitura.",
    summary: "Sumário",
    readLabel: "lido",
    continueLabel: "Continuar",
    startReading: "Começar a ler",
    previousChapter: "Capítulo anterior",
    completeAndNext: "Concluir e próximo",
    finishBook: "Concluir livro",
    chapters: "capítulos",
    inEditing: "Em Edição",
    chaptersIn: 'Capítulos em',
    pageOf: "Página ",
    of: " de ",
    backToChapters: "Voltar para seleção de capítulos",
    sendSuggestion: "Enviar Sugestão",
    typeSuggestion: "Digite sua sugestão...",
    send: "Enviar",
    suggestionEmpty: "A sugestão não pode estar vazia",
    suggestionSuccess: "Sugestão enviada com sucesso",
    suggestionFail: "Falha ao enviar sugestão: ",
    suggestionTypeLabel: "Tipo de Sugestão (opcional):",
    selectSuggestionType: "Selecione uma classificação para a sugestão...",
    suggestionTypeEmpty: "Por favor, selecione um tipo de sugestão.",
    failSuggestionTypes: "Falha ao buscar tipos de sugestão: ",
    contentInDevelopment: "Conteúdo em Desenvolvimento",
    bookInEditingMessage:
      'O livro "{title}" está em edição e ficará disponível em breve.',
    chapterInEditingMessage:
      'O capítulo "{title}" está em edição e ficará disponível em breve.',
    understood: "Entendi",
    listProducts: "Listar Produtos",
    backToReader: "Voltar ao Leitor",
    products: "Produtos",
    productList: "Lista de Produtos",
    id: "ID",
    name: "Nome",
    description: "Descrição",
    storageMethod: "Método de Armazenamento",
    formulation: "Formulação",
    controlTarget: "Alvo de Controle",
    activeIngredient: "Ingrediente Ativo",
    activeConcentration: "Concentração Ativa",
    recommendedDose: "Dose Recomendada",
    applicationMethod: "Método de Aplicação",
    benefit: "Benefício",
    type: "Tipo",
    details: "Detalhes",
    viewDetails: "Ver Detalhes",
    productDetails: "Detalhes do Produto",
    close: "Fechar",
    loadingProducts: "Carregando produtos...",
    failProducts: "Falha ao buscar produtos: ",
    noProducts: "Nenhum produto encontrado para este capítulo.",
    pesticides: "Defensivos",
    fertilizers: "Fertilizantes",
    noPesticides: "Nenhum defensivo encontrado para este capítulo.",
    noFertilizers: "Nenhum fertilizante encontrado para este capítulo.",
    listContributors: "Listar Contribuidores",
    contributors: "Contribuidores",
    contributorsList: "Lista de Contribuidores",
    loadingContributors: "Carregando contribuidores: ",
    failContributors: "Falha ao buscar contribuidores: ",
    noContributors: "Nenhum contribuidor encontrado para este capítulo.",
    failChapterAccess: "Falha ao buscar acesso ao capítulo: ",
    loading: "Carregando...",
    search: "Buscar",
    enterKeyword: "Digite uma palavra-chave para buscar capítulos...",
    clear: "Limpar",
    pagePreview: "Página ",
    itemsPerPage: "Itens por página: ",
    show: "Mostrando",
    to: " a ",
    book: "livros",
    notFound: "Nenhum capítulo encontrado",
    removeImage: "Remover Imagem",
    invalidImageType: "Tipo de imagem inválido. Por favor, envie um arquivo de imagem válido.",
    imageTooLarge: "O tamanho da imagem excede o limite de 2MB. Por favor, envie uma imagem menor.",
    imageUpload: "Envio de Imagem",
    selectedImage: "Imagem Selecionada: ",
    uploadImage: "Enviar Imagem",
    suggestionType: "Tipo de Sugestão",
    loadingTypes: "Carregando tipos de sugestão...",
    fileTooLarge: "Arquivo muito grande. Tamanho máximo permitido: 10MB",
    fileProcessingError: "Erro ao processar o arquivo. Tente novamente.",
    attachFile: "Anexar arquivo (opcional)",
    allFileTypesAccepted: "Todos os tipos de arquivo são aceitos. Tamanho máximo: 10MB",
    selectedFile: "Arquivo selecionado: ",
    fileSize: "Tamanho",
    fileType: "Tipo",
    removeFile: "Remover arquivo",
    unknown: "Desconhecido",
    scrollView: 'Visualização em Scroll',
    paginatedView: 'Visualização Paginada',
    pages: 'páginas',
    backToTop: "Voltar ao topo",
    addComment: "Adicionar comentário",
    fontSize: "Fonte:",
    sugestionInfo: "As sugestões são visiveis apenas para você (na tela Meus Comentários) e para os editores. Elas são analisadas periodicamente pela equipe editorial e podem ser incorporadas em futuras edições do livro."
  },
  en: {
    reading: "Reading",
    backToBooks: "Back to book selection",
    failBooks: "Failed to fetch books: ",
    selectBook: "Select a Book",
    libraryLead: "Choose a book to start reading.",
    noBooks: "No books available",
    noBooksDescription: "There are no published books to read yet.",
    summary: "Contents",
    readLabel: "read",
    continueLabel: "Continue",
    startReading: "Start reading",
    previousChapter: "Previous chapter",
    completeAndNext: "Complete & next",
    finishBook: "Finish book",
    chapters: "chapters",
    inEditing: "In Editing",
    chaptersIn: 'Chapters in',
    pageOf: "Page ",
    of: " of ",
    backToChapters: "Back to chapter selection",
    sendSuggestion: "Send Suggestion",
    typeSuggestion: "Type your suggestion...",
    send: "Send",
    suggestionEmpty: "Suggestion cannot be empty",
    suggestionSuccess: "Suggestion sent successfully",
    suggestionFail: "Failed to send suggestion: ",
    suggestionTypeLabel: "Suggestion Type (optional):",
    selectSuggestionType: "Select a typing for the suggestion...",
    suggestionTypeEmpty: "Please select a suggestion type.",
    failSuggestionTypes: "Failed to fetch suggestion types: ",
    contentInDevelopment: "Content in Development",
    bookInEditingMessage:
      'The book "{title}" is being edited and will be available soon.',
    chapterInEditingMessage:
      'The chapter "{title}" is being edited and will be available soon.',
    understood: "Got it",
    listProducts: "List Products",
    backToReader: "Back to Reader",
    products: "Products",
    productList: "Product List",
    id: "ID",
    name: "Name",
    description: "Description",
    storageMethod: "Storage Method",
    formulation: "Formulation",
    controlTarget: "Control Target",
    activeIngredient: "Active Ingredient",
    activeConcentration: "Active Concentration",
    recommendedDose: "Recommended Dose",
    applicationMethod: "Application Method",
    benefit: "Benefit",
    type: "Type",
    details: "Details",
    viewDetails: "View Details",
    productDetails: "Product Details",
    close: "Close",
    loadingProducts: "Loading products...",
    failProducts: "Failed to fetch products: ",
    noProducts: "No products found for this chapter.",
    pesticides: "Pesticides",
    fertilizers: "Fertilizers",
    noPesticides: "No pesticides found for this chapter.",
    noFertilizers: "No fertilizers found for this chapter.",
    listContributors: "List Contributors",
    contributors: "Contributors",
    contributorsList: "Contributors List",
    loadingContributors: "Loading contributors...",
    failContributors: "Failed to fetch contributors: ",
    noContributors: "No contributors found for this chapter.",
    failChapterAccess: "Failed to fetch chapter access: ",
    loading: "Loading...",
    search: "Search",
    enterKeyword: "Enter a keyword to search chapters...",
    clear: "Clear",
    pagePreview: "Page ",
    itemsPerPage: "Items per page: ",
    show: "Showing",
    to: " to ",
    book: "books",
    notFound: "No chapter found",
    removeImage: "Remove Image",
    invalidImageType: "Invalid image type. Please upload a valid image file.",
    imageTooLarge: "Image size exceeds the limit of 2MB. Please upload a smaller image.",
    imageUpload: "Image Upload",
    selectedImage: "Selected Image: ",
    uploadImage: "Upload Image",
    suggestionType: "Suggestion Type",
    loadingTypes: "Loading suggestion types...",
    fileTooLarge: "File too large. Maximum allowed size: 10MB",
    fileProcessingError: "Error processing the file. Please try again.",
    attachFile: "Attach file (optional)",
    allFileTypesAccepted: "All file types are accepted. Maximum size: 10MB",
    selectedFile: "Selected file: ",
    fileSize: "Size",
    fileType: "Type",
    removeFile: "Remove file",
    unknown: "Unknown",
    scrollView: 'Scroll View',
    paginatedView: 'Paginated View',
    pages: 'pages',
    backToTop: "Back to top",
    addComment: "Add comment",
    fontSize: "Font Size:",
    sugestionInfo: "Suggestions are only visible to you (in the My Comments screen) and to the editors. They are periodically reviewed by the editorial team and may be incorporated into future editions of the book."
  },
};

export default translations;


